











import { Vue, Component, Model, Prop } from "vue-property-decorator";
import { busy } from "@/loader";

@Component
export default class YesNoCheckbox extends Vue {
	@Model("input", { type: Boolean, required: true })
	public readonly value!: boolean;

	@Prop({ type: Boolean, default: false })
	public canEdit!: boolean;

	public get isBusy(): boolean {
		return busy.status;
	}

	public get checked(): boolean {
		return this.value;
	}
	public set checked(value: boolean) {
		this.$emit("input", value);
	}
}
